export const sportAliases: { [key: number]: string } = {
  17: 'american-football',
  2: 'aussie-rules',
  271554: 'badminton',
  3: 'baseball',
  4: 'basketball',
  11205863: 'basketball-3x3',
  7950337: 'beach-volley',
  5: 'boxing',
  6: 'cricket',
  7: 'cycling',
  8: 'darts',
  10915624: 'esport',
  491393: 'futsal',
  6463040: 'gaelic-football',
  12: 'golf',
  99614: 'handball',
  208627: 'field-hockey',
  14: 'horse-racing',
  6463041: 'hurling',
  15: 'ice-hockey',
  300115: 'karate',
  16: 'motorsport',
  73743: 'rugby-league',
  73744: 'rugby-union',
  22: 'snooker',
  10: 'soccer',
  437727: 'squash',
  269467: 'table-tennis',
  24: 'tennis',
  91189: 'volleyball',
  276032: 'waterpolo',
};
